import type { FaireProductEntity } from "../../entity_types/product";

export const p_46myrgpuzw: FaireProductEntity = {
  token: "p_46myrgpuzw",
  type: "product",
  name: "Patchwork hippie adjustable cotton summer hulter dress",
  brandToken: "b_9jg4fbzgpg",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/c95e3551b4d31a926d460dba4f374a01028b82a409efea87db656fb77ef6fbdf.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7e6bfd3d31049a03bd03b6ad194f6762325279386441c075db9b42187482e622.jpeg",
    "https://cdn.faire.com/fastly/3be88f6d269f4b50917212d4601fba292caf4cb14f6ce7c074a37c058eadd1c4.jpeg",
  ],
  priceDollars: 27.72,
  description:
    "Fine cotton one size fits most adjustable hippy boho print summer dress \n100 % cotton made in Nepal ",
  tags: [],
  msrpDollars: 55.43,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:27:22.699Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
